document.addEventListener('DOMContentLoaded', () => {
    const body = document.body;
    const nav = document.querySelector('.nav');
    const navWrap = document.querySelector('.navwrap');
    const burger = document.querySelector('.burger');
    const breakpoint = 992;

    if (!nav || !navWrap || !burger) {
        return;
    }

    let isMobileView = window.innerWidth < breakpoint;
    let activeSubmenu = null;

    const navWindow = document.querySelector('.navwindow') || (() => {
        const overlay = document.createElement('div');
        overlay.className = 'navwindow';
        body.appendChild(overlay);

        return overlay;
    })();

    const isMobile = () => window.innerWidth < breakpoint;
    const navRoot = nav.querySelector(':scope > ul');
    const topLevelSelector = '.nav > ul > li > button, .nav > ul > li > a, .nav-aux > li > button, .nav-aux > li > a';

    const getMenuTrigger = (menuItem) => {
        if (!menuItem) {
            return null;
        }

        return menuItem.querySelector(':scope > button');
    };

    const getSubmenu = (menuItem) => {
        if (!menuItem) {
            return null;
        }

        return menuItem.querySelector(':scope > ul');
    };

    const setExpanded = (menuItem, isExpanded) => {
        const trigger = getMenuTrigger(menuItem);
        if (trigger) {
            trigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        }
    };

    const getParentSubmenu = (submenu) => {
        if (!submenu) {
            return null;
        }

        const parentItem = submenu.closest('li.menu-item-has-children');
        if (!parentItem) {
            return null;
        }

        const parentSubmenu = parentItem.closest('ul');
        if (!parentSubmenu || parentSubmenu === navRoot) {
            return null;
        }

        return parentSubmenu;
    };

    const closeSubmenu = (menuItem) => {
        if (!menuItem) {
            return;
        }
        menuItem.classList.remove('__active');
        const submenu = getSubmenu(menuItem);
        if (submenu) submenu.classList.remove('__active');
        setExpanded(menuItem, false);
        if (isMobile() && submenu && submenu === activeSubmenu) {
            activeSubmenu = getParentSubmenu(submenu);
            updateMobileTabOrder(activeSubmenu);
        }
    };

    const closeSiblingSubmenus = (menuItem) => {
        if (!menuItem || !menuItem.parentElement) {
            return;
        }
        Array.from(menuItem.parentElement.children).forEach((sibling) => {
            if (sibling !== menuItem && sibling.classList.contains('menu-item-has-children')) {
                closeSubmenu(sibling);
            }
        });
    };

    const closeAllSubmenus = () => {
        document
            .querySelectorAll('.navwrap li.menu-item-has-children.__active, .aux-nav li.menu-item-has-children.__active')
            .forEach((item) => closeSubmenu(item));
        document
            .querySelectorAll('.navwrap li.menu-item-has-children > ul.__active, .aux-nav li.menu-item-has-children > ul.__active')
            .forEach((submenu) => submenu.classList.remove('__active'));
        document
            .querySelectorAll('.navwrap li.menu-item-has-children > button[aria-expanded=\"true\"], .aux-nav li.menu-item-has-children > button[aria-expanded=\"true\"]')
            .forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
        if (isMobile()) {
            activeSubmenu = null;
            updateMobileTabOrder(null);
        }
    };

    const setMenuTabIndex = (value) => {
        navWrap.querySelectorAll('a, button').forEach((el) => {
            el.setAttribute('tabindex', value);
        });
    };

    const updateMobileTabOrder = (submenu) => {
        setMenuTabIndex('-1');
        if (!body.classList.contains('__mobile')) {
            return;
        }
        if (!submenu) {
            navWrap.querySelectorAll(topLevelSelector).forEach((el) => {
                el.removeAttribute('tabindex');
            });
            return;
        }
        submenu.querySelectorAll('a, button').forEach((el) => {
            el.removeAttribute('tabindex');
        });
        submenu.querySelectorAll('.backto button, .backto a').forEach((el) => {
            el.setAttribute('tabindex', '0');
        });
    };

    const focusFirstTopLevel = () => {
        const first = navWrap.querySelector(topLevelSelector);
        if (first) {
            first.focus();           
        }
    };

    const focusFirstInSubmenu = (submenu) => {
        if (!submenu) {
            return;
        }

        const firstItem = submenu.querySelector('.backto button, .backto a, a[href], button:not([disabled])');
        if (firstItem) {
            firstItem.focus();
        }
    };

    const openMobileMenu = () => {
        body.classList.add('__mobile');
        navWrap.classList.add('__active');
        burger.classList.add('__active');
        navWindow.style.display = 'block';
        activeSubmenu = null;
        updateMobileTabOrder(null);
        focusFirstTopLevel();
    };

    const closeMobileMenu = () => {
        body.classList.remove('__mobile');
        navWrap.classList.remove('__active');
        burger.classList.remove('__active');
        navWindow.style.display = 'none';
        activeSubmenu = null;
        closeAllSubmenus();
        setMenuTabIndex('-1');
    };

    const openSubmenu = (menuItem, focusSubmenu) => {
        if (!menuItem) {
            return;
        }
        closeSiblingSubmenus(menuItem);
        menuItem.classList.add('__active');

        const submenu = getSubmenu(menuItem);
        if (submenu) {
            submenu.classList.add('__active');
        }
        setExpanded(menuItem, true);
        if (isMobile()) {
            activeSubmenu = submenu;
            updateMobileTabOrder(submenu);
        }
        if (focusSubmenu) {
            focusFirstInSubmenu(submenu);
        }
    };

    const toggleSubmenu = (menuItem, focusSubmenu) => {
        if (!menuItem) {
            return;
        }

        const isActive = menuItem.classList.contains('__active');
        if (isActive) {
            closeSubmenu(menuItem);
        } else {
            openSubmenu(menuItem, focusSubmenu);
        }
    };

    const updateSubmenuAlignment = () => {
        if (isMobile()) {
            return;
        }

        const lists = document.querySelectorAll('.navwrap ul, .aux-nav ul');
        lists.forEach((list) => list.classList.remove('left'));
        lists.forEach((list) => {
            if (!list.getClientRects().length) {
                return;               
            }
            const rect = list.getBoundingClientRect();
            if (rect.x + rect.width > window.innerWidth) {
                list.classList.add('left');
            }
        });
    };

    const getFocusableItems = (container) => {
        if (!container) {
            return [];
        }
        return Array.from(container.querySelectorAll('a[href], button:not([disabled])')).filter((el) => {
            if (el.getAttribute('tabindex') === '-1') return false;
            return el.getClientRects().length > 0;
        });
    };

    const isTopLevelMenu = (menu) => {
        if (!menu) {
            return false;
        }
        if (menu === navRoot) {
            return true;
        }
        return menu.classList.contains('nav-aux');
    };

    const handleBackAction = (backButton) => {
        const submenu = backButton.closest('ul');
        if (submenu) {
            submenu.classList.remove('__active');
        }

        const parentItem = submenu ? submenu.closest('li.menu-item-has-children') : null;
        const parentMenu = parentItem ? parentItem.closest('ul') : null;
        if (parentMenu && !isTopLevelMenu(parentMenu)) {
            parentMenu.classList.add('__active');
        }
        if (parentItem) {
            closeSubmenu(parentItem);
            const trigger = getMenuTrigger(parentItem) || parentItem.querySelector(':scope > a');
            if (trigger) trigger.focus();
        }
        if (isMobile()) {
            if (isTopLevelMenu(parentMenu)) {
                activeSubmenu = null;
                updateMobileTabOrder(null);
            } else {
                activeSubmenu = parentMenu;
                updateMobileTabOrder(parentMenu);
            }
        }
    };

    burger.addEventListener('click', (event) => {
        event.preventDefault();
        if (body.classList.contains('__mobile')) {
            closeMobileMenu();
        } else {
            openMobileMenu();
        }
    });

    navWindow.addEventListener('click', () => {
        closeMobileMenu();
    });

    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') {
            return;
        }
        if (isMobile()) {
            if (body.classList.contains('__mobile')) {
                closeMobileMenu();
                burger.focus();
            }
        } else {
            closeAllSubmenus();
        }
    });

    document.addEventListener('click', (event) => {
        if (isMobile()) {
            return;
        }
        if (!event.target.closest(".nav[aria-label='Primary']") && !event.target.closest('.aux-nav')) {
            closeAllSubmenus();
        }
    });

    document.addEventListener('focusin', (event) => {
        if (isMobile()) {
            return;
        }
        const target = event.target;
        const hasActive = navWrap.querySelector('li.menu-item-has-children.__active')
            || document.querySelector('.aux-nav li.menu-item-has-children.__active');
        if (!hasActive) {
            return;
        }
        if (!target.closest('li.menu-item-has-children.__active')) {
            closeAllSubmenus();
        }
    });

    navWrap.addEventListener('click', (event) => {
        const target = event.target;
        const backButton = target.closest('.backto');
        if (backButton && isMobile()) {
            event.preventDefault();
            event.stopPropagation();
            handleBackAction(backButton);
            return;
        }

        const menuItem = target.closest('li.menu-item-has-children');
        if (!menuItem) {
            return;
        }

        const isButtonTrigger = target.matches('button');
        const isLinkTrigger = target.matches('a');

        if (isMobile()) {
            if (isButtonTrigger) {
                event.preventDefault();
                event.stopPropagation();
                openSubmenu(menuItem, true);
            }
            return;
        }

        if (isButtonTrigger) {
            event.preventDefault();
            toggleSubmenu(menuItem, false);
            updateSubmenuAlignment();
        }
    });

    document.addEventListener('click', (event) => {
        if (isMobile()) {
            return;
        }

        const target = event.target;
        if (!target.closest('.aux-nav')) {
            return;
        }

        const menuItem = target.closest('li.menu-item-has-children');
        if (!menuItem) {
            return;
        }

        const isButtonTrigger = target.matches('button');
        if (isButtonTrigger) {
            event.preventDefault();
            toggleSubmenu(menuItem, false);
            updateSubmenuAlignment();
        }
    });

    navWrap.addEventListener('keydown', (event) => {
        if (!isMobile()) {
            return;
        }

        const target = event.target;
        if (!target.matches('a, button')) {
            return;
        }

        if ((event.key === 'Enter' || event.key === ' ') && target.closest('.backto')) {
            event.preventDefault();
            event.stopPropagation();
            handleBackAction(target.closest('.backto'));
            return;
        }

        if (event.key === 'Tab' && body.classList.contains('__mobile')) {
            const scope = activeSubmenu || navWrap;
            const focusables = getFocusableItems(scope);
            if (focusables.length) {
                const first = focusables[0];
                const last = focusables[focusables.length - 1];
                if ((event.shiftKey && target === first) || (!event.shiftKey && target === last)) {
                    event.preventDefault();
                    closeMobileMenu();
                    burger.focus();
                    return;
                }
            }
        }

        if ((event.key === 'Enter' || event.key === ' ') && target.matches('button') && target.closest('li.menu-item-has-children')) {
            event.preventDefault();
            const menuItem = target.closest('li.menu-item-has-children');
            openSubmenu(menuItem, true);
        }
    });

    navWrap.addEventListener('mouseenter', updateSubmenuAlignment);
    navWrap.addEventListener('focusin', updateSubmenuAlignment);

    const handleResize = () => {
        const nowMobile = window.innerWidth < breakpoint;
        if (nowMobile !== isMobileView) {
            if (nowMobile) {
                activeSubmenu = null;
                closeAllSubmenus();
                setMenuTabIndex('-1');
            } else {
                closeMobileMenu();
                navWrap.querySelectorAll('[tabindex="-1"]').forEach((el) => el.removeAttribute('tabindex'));
            }
            isMobileView = nowMobile;
        }
    };

    if (isMobileView) {
        setMenuTabIndex('-1');
    }

    window.addEventListener('resize', () => {
        handleResize();
        updateSubmenuAlignment();
    });
});
